export const getIconSize = (leftIcon: boolean, rightIcon: boolean): string => {
  if (leftIcon && rightIcon) {
    return 'px-36'
  }
  if (leftIcon) {
    return `pl-36 pr-12`
  }
  if (rightIcon) {
    return `pr-36 pl-12`
  }
  return 'px-12'
}
